module.exports = __webpack_public_path__ + "static/media/overpass-regular.f3dbad81.ttf";